<template>
    <div class="word-classify-wrap">
        <div class="list-title">
            <RoundButton class="add-classify-btn" :text="addClassifyLabel" @btnClick="btnClick" />
            <div class="selected-content">
                <LangSelect :value="initLang" class="lang-select" @change="langChange" :requireAll="true"></LangSelect>
                <Select :initValue="initStatus" :options="statusOptions" class="status-select" @menuClick="statusChange" />
            </div>
        </div>
        <div class="word-classify-list" v-show="groupsListData.length > 0">
            <div class="list-content">
                <ClassifyItem v-for="item in groupsListData" :key="item.uId" :data="item" :actived="currentId" @itemClick="itemClick(item)" />
            </div>
            <div class="page-control">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="groupsTotal"
                    :pager-count="5"
                    @prev-click="prevClick"
                    @next-click="nextClick"
                    @current-change="pageChange"
                >
                </el-pagination>
            </div>
        </div>
        <div class="no-word-classify" v-show="groupsListData.length === 0">
            {{ noDataLabel }}
        </div>
    </div>
</template>

<script>
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import Select from "@/views/zhiji/bComponents/inputs/Select";
import LangSelect from "@/components/langSelect";
import ClassifyItem from "./ClassifyItem";
import AddClassifyModal from "./AddClassifyModal";

import { STATIC_IMG_PATH } from "@/views/zhiji/js/common/constants.js";
import { statusOptions } from "../sensitiveWordConfig.js";
import i18n from "@/i18n";

export default {
    name: "SensitiveWordsClassify",
    props: ["data"],
    components: {
        RoundButton,
        Select,
        ClassifyItem,
        LangSelect
    },
    data() {
        return {
            addIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -56px 0px",
            hoverIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -56px -22px",
            initLang: "all",
            initStatus: "all",
            curPage: 1,
            curPageLen: 10
        };
    },
    computed: {
        addClassifyLabel() {
            return this.$t("zhiji.sensitiveWord.addClassifyLabel");
        },
        statusOptions() {
            return statusOptions();
        },
        groupsListData() {
            return this.getStorePorp("sensitiveGroupData");
        },
        groupsTotal() {
            return this.getStorePorp("groupTotals");
        },
        currentId() {
            return this.getStorePorp("currentGroupId");
        },
        noDataLabel() {
            return this.$t("zhiji.common.noData");
        }
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.sensitiveWords[propName];
        },
        btnClick() {
            this.$store.dispatch("zhiji/showModal", {
                type: AddClassifyModal,
                data: ""
            });
        },
        itemClick(data) {
            this.getStorePorp("sensitiveDetail").updateState ? this.saveEditWords(data) : this.updateCurrentData(data);
        },
        updateCurrentData(data) {
            this.$store.commit("zhiji/updateCurrentId", data.uId);
            this.$store.commit("zhiji/updateCurSensitiveWords", data.wordsArr);
        },
        saveEditWords(data) {
            // 待确认 放弃编辑时是否保存为草稿状态
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: i18n.t("zhiji.knowlege.quesEditModal.recomSaveToDraft"),
                    cancel: () => {},
                    confirm: () => {
                        this.$store.dispatch("zhiji/updateSensitiveGroup", {
                            ...this.data,
                            status: "draft"
                        });
                        this.$store.commit("zhiji/updateCurSensitiveWords", data.wordsArr);
                    }
                }
            });
        },
        langChange(data) {
            this.curPage = 1;
            this.initLang = data;
            this.$store.dispatch("zhiji/querySensitiveGroupList", {
                page: this.curPage,
                size: this.curPageLen,
                lang: this.initLang === "all" ? "" : this.initLang
            });
        },
        statusChange(data) {
            this.curPage = 1;
            this.initStatus = data.value;
            this.$store.dispatch("zhiji/querySensitiveGroupList", {
                page: this.curPage,
                size: this.curPageLen,
                status: this.initStatus === "all" ? "" : this.initStatus
            });
        },
        prevClick(data) {
            this.curPage = data;
            this.getSensitiveGroupData();
        },
        nextClick(data) {
            this.curPage = data;
            this.getSensitiveGroupData();
        },
        pageChange(data) {
            this.curPage = data;
            this.getSensitiveGroupData();
        },
        getSensitiveGroupData() {
            this.$store.dispatch("zhiji/querySensitiveGroupList", {
                page: this.curPage,
                size: this.curPageLen
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.word-classify-wrap {
    display: flex;
    flex-direction: column;
    width: 380px;
    position: relative;
    height: 100%;
    box-sizing: border-box;
    border-right: 1px solid #e3ecf5;
    background: #f2f7fb;
    overflow-x: hidden;
    flex-shrink: 0;
    flex-flow: 0;
    overflow-y: auto;
    .list-title {
        font-size: 14px;
        padding: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #d9e4ef;
        .add-classify-btn {
            position: relative;
            width: 108px;
            box-sizing: border-box;
        }
    }
    .selected-content {
        display: flex;
        justify-content: space-between;
        .lang-select,
        .status-select {
            margin-right: 8px;
            width: 50%;
            background: #fff;
        }
        > div {
            &:last-child {
                margin-right: 0;
            }
        }
    }
    .word-classify-list {
        flex: 1;
        display: flex;
        flex-direction: column;
        .list-content {
            flex: 1;
            overflow-y: auto;
            font-size: 12px;
            border-width: 0 0 1px 0;
            border-color: #d8e4f0;
            border-style: solid;
        }
        .page-control {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 18px 8px 18px 24px;
            text-align: center;
            color: rgba(65, 71, 94, 0.7);
        }
    }

    .no-word-classify {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 50px;
        box-sizing: border-box;
    }
}
</style>
